import { Vue, Component } from 'vue-property-decorator'
import gql from 'graphql-tag'

import { Dataset as DatasetType, Maybe } from '@/@types/graphql'

@Component({ name: 'dataset-service' })
export default class Dataset extends Vue {

    async GET_DATASETS (): Promise<DatasetType[]> {
        const query = gql`
            query datasets {
                datasets {
                    key
                    value
                }
            }
        `
        const { data } = await this.$apollo.query({ query })
        return data.datasets
    }

    async GET_DATASET (key: string): Promise<Maybe<DatasetType>> {
        try {
            const datasets = await this.GET_DATASETS()
            return datasets.find((dataset: DatasetType) => dataset.key === key) || null
        } catch (err) {
            console.log(`Error fetching dataset ${key} : ${err}`)
            return null
        }
        
    // const variables = { key }
    // const query = gql`      
    //     query dataset ($key: String!) {
    //         dataset (key: $key) {
    //             value
    //         }
    //     }
    // `
    // const { data } = await this.$apollo.query({ query, variables })
    // return data.dataset
  }

}
